import { Injectable, signal, computed } from '@angular/core';

export interface Chain {
  name: string;
  label_asym_id: string;
  length: number;
  sequenceEnd: number;
  sequenceStart: number;
}

export interface PaeMatrix {
  n: number;
  data: number[];
}

@Injectable({
  providedIn: 'root'
})
export class PaeDataService {

  // Signals
  private _chains = signal<Chain[]>([]);
  public chains = computed(() => this._chains());

  private _paeMatrix = signal<PaeMatrix | undefined>(undefined);
  public paeMatrix = computed(() => this._paeMatrix());

  /** ----------------------------------
   *  Update chains (mock or server data)
   *  ---------------------------------- */
  setChains(chains: Chain[]) {
    this._chains.set(chains);
  }

  /** ----------------------------------
   *  Fetch JSON PAE file + chains
   *  ---------------------------------- */
  async fetchPAEMatrix(url: string, sequenceEnd: number, cut?: number): Promise<PaeMatrix | undefined> {
    // const tempurl = 'http://localhost:4200/assets/newPAE.json';
   
    const response = await fetch(url);
    if (!response.ok) return undefined;

    const js = await response.json();

    if (js[0].chains && js[0].chains.length > 1) {
    
      const transformedChains = js[0].chains.map(chain => ({
        name: chain.name,
        label_asym_id: chain.label_asym_id ?? undefined,
        length: chain.sequenceEnd,         // same as sequenceEnd
        sequenceEnd: chain.sequenceEnd,
        sequenceStart: chain.sequenceStart
      }));
    
      this.setChains(transformedChains);
    } else {
      this.setChains([
        { name: 'ProteinA', label_asym_id: undefined, length: sequenceEnd, sequenceEnd:sequenceEnd, sequenceStart:1 },
      ]);
    }

    let pae: number[][];

    // JSON might be array or object, handle both
    if (Array.isArray(js)) {
      pae = js[0].predicted_aligned_error as number[][];
    } else {
      pae = js.predicted_aligned_error as number[][];
    }

    // optional cut
    if (cut !== undefined) {
      pae = pae.slice(0, cut).map(row => row.slice(0, cut));
    }

    const result: PaeMatrix = {
      n: pae.length,
      data: pae.flat()
    };

    // store result in signal so other components can react
    return result;
  }
}
